import axios from "axios";
import router from "@/router/";
import Swal from "sweetalert2";

const baseUrl = process.env.VUE_APP_API_URL_V1;

const app = {
  state: {
    loading: false,
    login: {
      username: "",
      pw: "",
    },
    registrasi: {
      nik: "",
      email: "",
      name: "",
      no_hp: "",
      pw: "",
      pw_confirm: "",
    },
  },
  mutations: {
    SET_LOADING_APP(state, payload) {
      state.loading = payload;
    },
    SET_FORM_LOGIN(state, payload) {
      state.login[payload.key] = payload.value;
    },
    SET_FORM_REGISTRASI(state, payload) {
      state.registrasi[payload.key] = payload.value;
    },
  },
  actions: {
    async AuthLogin(context) {
      try {
        context.commit("SET_LOADING_APP", true);

        const result = await axios({
          url: `${baseUrl}/UserAccount/Login`,
          method: "POST",
          data: context.state.login,
        });
        localStorage.setItem("token", result.data.token);
        localStorage.setItem("username", result.data.name);
        localStorage.setItem("nik", result.data.nik);
        localStorage.setItem("tokenExpire", result.data.tokenExpire);

        // console.log(result, "result");
        router.push("/");
      } catch (error) {
        if (error.message === "Network Error") {
          Swal.fire("Tidak ada jaringan!", "", "error");
        } else {
          Swal.fire("Gagal!", JSON.parse(error.request.response).head, "error");
        }
      } finally {
        context.commit("SET_LOADING_APP", false);
      }
    },
    async AuthRegister(context) {
      try {
        context.commit("SET_LOADING_APP", true);

        if (
          context.state.registrasi.pw !== context.state.registrasi.pw_confirm
        ) {
          Swal.fire("Konfirmasi password tidak sama!", "", "error");
          return;
        }

        await axios({
          url: `${baseUrl}/UserAccount/Signup`,
          method: "POST",
          data: context.state.registrasi,
        });

        Swal.fire("Berhasil!", "Berhasil Membuat Akun", "success");
        router.push("/login");
      } catch (error) {
        if (error.message === "Network Error") {
          Swal.fire("Tidak ada jaringan!", "", "error");
        } else {
          Swal.fire("Gagal!", JSON.parse(error.request.response).head, "error");
        }
      } finally {
        context.commit("SET_LOADING_APP", false);
      }
    },
    async ForgotPassword(context, data) {
      try {
        context.commit("SET_LOADING_APP", true);

        await axios({
          url: `${baseUrl}/UserAccount/forgotpassword`,
          method: "POST",
          data: data,
        });

        Swal.fire({
          title: "Success",
          text: "Silahkan cek email anda untuk reset password",
          icon: "success",
        });
        router.push("/login");
      } catch (error) {
        if (error.message === "Network Error") {
          Swal.fire("Tidak ada jaringan!", "", "error");
        } else {
          Swal.fire("Gagal!", JSON.parse(error.request.response).head, "error");
        }
      } finally {
        context.commit("SET_LOADING_APP", false);
      }
    },
  },
};

export default app;
